import React, { useState, useEffect } from "react";
import { db, storage, auth } from "../firebaseConfig";
import {
  collection,
  addDoc,
  getDocs,
  query,
  where,
  orderBy,
  serverTimestamp,
  Timestamp,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import "../styles/Form.css";

const KazaEkle = () => {
  const [plakalar, setPlakalar] = useState([]);
  const [personeller, setPersoneller] = useState([]);
  const [formData, setFormData] = useState({
    tarih: "",
    saat: "",
    plaka: "",
    personel: "",
    aciklama: "",
    kazaBasligi: "",
  });
  const [kazaFotograf, setKazaFotograf] = useState([]);
  const [raporDosya, setRaporDosya] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const plakaQuery = query(
        collection(db, "plates"),
        where("active", "==", true),
        orderBy("plate")
      );
      const personelQuery = collection(db, "personeller");

      const [plakaSnap, personelSnap] = await Promise.all([
        getDocs(plakaQuery),
        getDocs(personelQuery),
      ]);

      const plakaList = plakaSnap.docs.map((doc) => doc.data().plate).sort();
      const personelList = personelSnap.docs
        .map((doc) => {
          const data = doc.data();
          return `${data.ad} ${data.soyad}`;
        })
        .sort();

      setPlakalar(plakaList);
      setPersoneller(personelList);
    };

    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const currentUser = auth.currentUser;
    if (!currentUser) {
      alert("Kullanıcı giriş yapmamış!");
      return;
    }

    let kazaFotoURL = [];
    let raporURL = "";

    try {
      // Fotoğraf yükleme
      if (kazaFotograf.length > 0) {
        for (const file of kazaFotograf) {
          const kazaRef = ref(storage, `kazalar/foto/${Date.now()}-${file.name}`);
          await uploadBytes(kazaRef, file);
          const url = await getDownloadURL(kazaRef);
          kazaFotoURL.push(url);
        }
      }

      // Rapor yükleme
      if (raporDosya) {
        const raporRef = ref(storage, `kazalar/rapor/${Date.now()}-${raporDosya.name}`);
        await uploadBytes(raporRef, raporDosya);
        raporURL = await getDownloadURL(raporRef);
      }

      // Tarihi Timestamp'e çevir
      const tarihObj = new Date(formData.tarih);
      const tarihTS = isNaN(tarihObj.getTime()) ? null : Timestamp.fromDate(tarihObj);

      await addDoc(collection(db, "kazalar"), {
        ...formData,
        tarih: tarihTS,
        kazaFotoURL,
        raporURL,
        createdBy: currentUser.email,
        createdAt: serverTimestamp(),
      });

      alert("Kaza kaydı başarıyla eklendi.");

      setFormData({
        tarih: "",
        saat: "",
        plaka: "",
        personel: "",
        aciklama: "",
        kazaBasligi: "",
      });
      setKazaFotograf([]);
      setRaporDosya(null);
    } catch (error) {
      console.error("❌ Kayıt hatası:", error);
      alert("Kaza kaydı sırasında hata oluştu.");
    }
  };

  return (
    <div className="form-container">
      <h2>Kaza Ekle</h2>
      <form onSubmit={handleSubmit}>
        <label>Tarih:</label>
        <input
          type="date"
          name="tarih"
          value={formData.tarih}
          onChange={handleChange}
          required
        />

        <label>Saat:</label>
        <input
          type="time"
          name="saat"
          value={formData.saat}
          onChange={handleChange}
          required
        />

        <label>Plaka:</label>
        <input
          list="plaka-list"
          name="plaka"
          value={formData.plaka}
          onChange={handleChange}
          required
        />
        <datalist id="plaka-list">
          {plakalar.map((p) => (
            <option key={p} value={p} />
          ))}
        </datalist>

        <label>Personel:</label>
        <input
          list="personel-list"
          name="personel"
          value={formData.personel}
          onChange={handleChange}
          required
        />
        <datalist id="personel-list">
          {personeller.map((p) => (
            <option key={p} value={p} />
          ))}
        </datalist>

        <label>Kaza Başlığı:</label>
        <input
          type="text"
          name="kazaBasligi"
          value={formData.kazaBasligi}
          onChange={handleChange}
          required
        />

        <label>Açıklama:</label>
        <textarea
          name="aciklama"
          value={formData.aciklama}
          onChange={handleChange}
          rows="4"
          required
        />

        <label>Kaza Fotoğraf(lar)ı:</label>
        <input
          type="file"
          accept="image/*"
          multiple
          onChange={(e) => setKazaFotograf(Array.from(e.target.files))}
        />

        <label>Kaza Raporu (PDF):</label>
        <input
          type="file"
          accept=".pdf"
          onChange={(e) => setRaporDosya(e.target.files[0])}
        />

        <button type="submit">Kaydet</button>
      </form>
    </div>
  );
};

export default KazaEkle;
